import { render, staticRenderFns } from "./ArtistTable.vue?vue&type=template&id=349f782e"
import script from "./ArtistTable.vue?vue&type=script&lang=js"
export * from "./ArtistTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports